import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import MaskedInput from 'react-text-mask';
import { getCountryByCode } from 'config/country-codes';
import { AsYouType } from 'libphonenumber-js';

import './phone.scss';

export const PhoneSimpleField = (props) => {
  const { label, onChange, countryCode, value, disabled, verifyField, testId } =
    props;

  const [prevValue, setPrevValue] = useState('');

  useEffect(() => {
    if (prevValue === value) {
      onChange('');
    }
  }, [countryCode]);

  useEffect(() => {
    setPrevValue(value);
  }, [value]);

  const { dialCode = '+1' } = getCountryByCode(countryCode) || {};

  let phone = value.replace(dialCode, '');

  const handleChange = (e) => {
    const phone = e.target.value.replace(/[()\s-]/g, '');

    if (isNaN(+phone)) {
      return;
    }
    onChange(phone ? dialCode + phone : '');
  };

  const asYouType = new AsYouType(countryCode);
  asYouType.input(phone);
  let mask = [];
  const template = asYouType.getTemplate() || '';
  if (template) {
    for (let i = 0; i < template.length; i++) {
      if (template[i] === 'x') {
        mask.push(/\d/);
      } else {
        mask.push(template[i]);
      }
    }

    asYouType.input(`${asYouType}1`);
    if (asYouType.getTemplate()) {
      mask.push(/\d/);
    }
  } else {
    mask = [
      /\d/,
      /\d/,
      /\d/,
      /\d/,
      /\d/,
      /\d/,
      /\d/,
      /\d/,
      /\d/,
      /\d/,
      /\d/,
      /\d/,
    ];
  }

  return (
    <label className="input-component">
      <span className="input-component__label">{`${label} ${dialCode}`}</span>
      <MaskedInput
        mask={mask}
        guide={false}
        onChange={handleChange}
        value={phone}
        onFocus={() => props.onFocus()}
        onBlur={() => props.onBlur()}
        name={props.name}
        disabled={disabled}
        data-testid={testId}
        style={{
          fontSize: verifyField && disabled && '12px',
          color: verifyField && disabled && '#8A929B',
        }}
      />
    </label>
  );
};

PhoneSimpleField.propTypes = {
  label: PropTypes.string,
  onChange: PropTypes.func,
  onFocus: PropTypes.func,
  onBlur: PropTypes.func,
  value: PropTypes.any,
  countryCode: PropTypes.string,
};

PhoneSimpleField.defaultProps = {
  label: 'Phone:',
  dateFormat: 'MM / DD / YYYY',
  timeFormat: false,
  onChange: (e) => {},
  onFocus: (e) => {},
  onBlur: (e) => {},
  value: '',
  countryCode: 'US',
};
